<div class="form-container">
  <h2>{{ 'Registro de servicios de facturación' }}</h2>
  <form [formGroup]="billingForm">
    <div class="form-group" *ngIf="hasRole(ROLE_SUPERADMIN)">
      <label>{{ "LABEL.PARTNER" | translate }}</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-university" aria-hidden="true"></i></div>
        </div>
        <select class="form-control ml-1 custom-width-select"
                formControlName="partner">
          <option *ngFor="let partner of partners"
                  [ngValue]="partner.id">
            {{ partner.name }}
        </select>
      </div>
      <small *ngIf="isInvalidControl('partner')" class="text-danger">Debe seleccionar el partner.</small>
    </div>
    <div class="form-group" *ngIf="hasRole(ROLE_SUPERADMIN)">
      <label for="enterpriseInput">{{ "LABEL.ENTERPRISE" | translate }}</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-building" aria-hidden="true"></i></div>
        </div>
        <select id="enterpriseInput"
                class="form-control"
                formControlName="enterprise">
          <option *ngFor="let enterprise of enterprises"
                  [ngValue]="enterprise.id">
            {{ enterprise.name }}
        </select>
      </div>
      <small *ngIf="isInvalidControl('enterprise')" class="text-danger">Debe seleccionar la empresa.</small>
    </div>
    <div class="form-group" *ngIf="hasRole(ROLE_SUPERADMIN)">
      <label for="billingServiceType">Tipo de servicio</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-building" aria-hidden="true"></i></div>
        </div>
        <select id="billingServiceType"
                class="form-control"
                formControlName="billingServiceType">
          <option *ngFor="let billingservicestype of billingServicesTypes"
                  [ngValue]="billingservicestype.id">
            {{ billingservicestype.name }}
        </select>
      </div>
      <small *ngIf="isInvalidControl('billingServiceType')" class="text-danger">Debe seleccionar el tipo de
        servicio</small>
    </div>
    <div class="form-group form-check">
      <input
        type="checkbox"
        id="discountPartner"
        class="form-check-input"
        formControlName="discountPartner"/>
      <label class="form-check-label" for="discountPartner">
        Descontar saldo del partner?
      </label>
    </div>
    <div class="form-group" *ngIf="!isDiscountPartner()">
      <label for="amount">Cantidad</label>
      <input
        type="number"
        id="amount"
        placeholder="Ingrese la cantidad"
        class="form-control"
        formControlName="amount"/>
      <small *ngIf="isInvalidControl('amount')"
             class="text-danger">
        Ingrese la canitdad, esta debe ser mayor a 0
      </small>
    </div>
    <div class="form-group" *ngIf="hasRole(ROLE_SUPERADMIN)">
      <label for="active">{{ "LABEL.STATE" | translate }}</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-building" aria-hidden="true"></i></div>
        </div>
        <select id="active"
                class="form-control"
                formControlName="active">
          <option [value]="true">{{ "LABEL.ACTIVE" | translate }}</option>
          <option [value]="false">{{ "LABEL.INACTIVE" | translate }}</option>
        </select>
      </div>
    </div>


    <div class="form-row mt-0 mb-2">
      <button type="button"
              class="btn btn-outline-danger w-100"
              (click)="cancel()">
        Cancelar
      </button>
    </div>
    <div class="form-row mt-0">
      <button type="button"
              (click)="save()"
              class="btn btn-outline-success w-100">
        {{ billingservices ? 'Actualizar' : 'Crear' }}
      </button>
    </div>
  </form>
</div>
<app-loading *ngIf="loading"></app-loading>
